<template>
  <section v-if="review !== null">
    <div class="modal-card" style="width: auto;">
      <header class="modal-card-head">
        <h1 class="title">
          {{ applyTypeName(apply_type) }}
          {{ number }}
          <span v-if="review.lock" class="has-text-danger">
            (鎖定)
          </span>
        </h1>
        <div class="column is-narrow">
          <div class="buttons">
            <b-button
              v-if="mode === 'review' && canReview(review)"
              :loading="sending"
              type="is-success"
              @click.prevent="onAudit"
            >
              {{ $t('attributes.gift_application_approve') }}
            </b-button>
            <b-button
              v-if="mode === 'review' && canReview(review)"
              :loading="sending"
              type="is-danger"
              @click.prevent="onReject"
            >
              {{ $t('attributes.gift_application_reject') }}
            </b-button>
            <b-button
              v-if="mode === 'review' && !review.lock && canVoid(review)"
              :loading="sending"
              type="is-danger"
              @click.prevent="onVoid"
            >
              {{ $t('attributes.gift_review_void') }}
            </b-button>
            <b-button
              v-if="mode === 'apply' && canClone(review)"
              :loading="sending"
              @click.prevent="onClone"
            >
              {{ $t('attributes.gift_review_clone') }}
            </b-button>
            <b-button
              v-if="mode === 'apply' && !review.lock && isAudit(review)"
              :loading="sending"
              :disabled="!canReturn(review)"
              @click.prevent="onReturn"
            >
              {{ $t('attributes.gift_review_return') }}
            </b-button>
            <b-button
              v-if="canPrint(review) && mode === 'apply'"
              :loading="sending"
              @click.prevent="onPrint"
            >
              {{ $t('attributes.gift_review_print') }}
            </b-button>
            <b-button
              v-if="
                review !== null && !review.lock && review.returns.length > 0
              "
              :loading="sending"
              @click.prevent="onPrintReturn(review.returns[0])"
            >
              {{ $t('attributes.gift_review_return_print') }}
            </b-button>
            <b-button
              v-if="
                review !== null &&
                  review.state === 'pending' &&
                  mode === 'apply'
              "
              type="is-danger"
              outlined
              @click.prevent="onCancelApply(review)"
            >
              {{ $t('attributes.cancel') + $t('attributes.gift_application') }}
            </b-button>
            <b-button
              v-if="false"
              type="is-danger"
              outlined
              @click.prevent="setReviewLock(review)"
            >
              解除鎖定
            </b-button>
          </div>
        </div>
      </header>
      <section class="modal-card-body">
        <div>
          <section v-if="review">
            <table class="table is-bordered is-narrow is-fullwidth">
              <tbody>
                <tr>
                  <th style="width: 60px;">
                    {{ $t('attributes.gift_application_state') }}
                  </th>
                  <th style="width: 120px;">
                    <P :class="stateColor(review)">
                      {{ stateName(review.state) }}
                      <span class="has-text-danger">
                        {{ returnState(review) }}
                      </span>
                    </P>
                  </th>
                  <th style="width: 60px;">
                    {{ $t('attributes.gift_review_sales') }}
                  </th>
                  <th style="width: 120px;">
                    {{ salesName(review) }}
                  </th>
                  <th style="width: 60px;">
                    {{ $t('attributes.gift_review_operator') }}
                  </th>
                  <th style="width: 120px;">
                    {{ operatorName(review) }}
                  </th>
                </tr>
                <tr>
                  <th style="width: 60px;">
                    {{ $t('attributes.gift_application_submit_date') }}
                  </th>
                  <th style="width: 120px;">
                    {{ formatDateTime(review.created_at) || '-' }}
                  </th>
                  <th style="width: 60px;">
                    {{ $t('attributes.gift_application_review_date') }}
                  </th>
                  <th>
                    {{ formatDateTime(review.review_date) || '-' }}
                  </th>
                  <th style="width: 60px;">
                    {{ $t('attributes.gift_review_reviewer') }}
                  </th>
                  <th>
                    {{ reviewerName(review) }}
                  </th>
                </tr>
                <tr>
                  <th style="width: 60px;">
                    {{ $t('attributes.gift_application_cancel_number') }}
                  </th>
                  <th>
                    {{ review.cancel_number || '-' }}
                  </th>
                  <th style="width: 60px;">
                    {{ $t('attributes.gift_application_cancel_date') }}
                  </th>
                  <th>
                    {{ formatDateTime(review.cancel_date) || '-' }}
                  </th>
                  <th style="width: 60px;">
                    {{ $t('attributes.gift_review_accountant') }}
                  </th>
                  <th>
                    {{ accountantName(review) }}
                  </th>
                </tr>
                <tr>
                  <th style="width: 60px;"></th>
                  <th></th>
                  <th style="width: 60px;">
                    {{ $t('attributes.gift_application_void_date') }}
                  </th>
                  <th>
                    {{ formatDateTime(review.void_date) || '-' }}
                  </th>
                  <th style="width: 60px;">
                    {{ $t('attributes.gift_review_voider') }}
                  </th>
                  <th>
                    {{ voiderName(review) }}
                  </th>
                </tr>
              </tbody>
            </table>

            <b-field
              v-if="isRejected(review)"
              :label="$t('attributes.gift_review_reject_reason')"
              label-position="on-border"
            >
              <b-input
                v-model="review.reason"
                readonly
                type="textarea"
                rows="2"
              />
            </b-field>

            <b-field
              v-if="isVoid(review)"
              :label="$t('attributes.gift_review_void_reason')"
              label-position="on-border"
            >
              <b-input
                v-model="review.reason"
                readonly
                type="textarea"
                rows="2"
              />
            </b-field>

            <table class="table is-bordered is-narrow is-fullwidth">
              <thead>
                <tr>
                  <th v-if="isFit(review)" class="nowrap">
                    {{ $t('attributes.user') }}
                  </th>
                  <th v-if="isGroup(review)" class="nowrap">
                    {{ $t('attributes.travel_group') }}
                  </th>
                  <th v-if="isGroup(review)">
                    {{ $t('attributes.group_name') }}
                  </th>
                  <th v-if="isGroup(review)">
                    {{ $t('attributes.departure_date') }}
                  </th>
                  <th class="nowrap">
                    {{ $t('attributes.gift_application_remark') }}
                  </th>
                  <th class="nowrap">{{ $t('attributes.gift') }}</th>
                  <th class="nowrap" style="text-align: right;">
                    {{ $t('attributes.gift_quantity') }}
                  </th>
                  <th class="nowrap" style="text-align: right;">
                    {{ $t('attributes.gift_net_price') }}
                  </th>
                  <th class="nowrap" style="text-align: right;">
                    {{ $t('attributes.gift_amount') }}
                  </th>
                </tr>
              </thead>
              <tbody
                v-for="app in review.applications"
                :key="`gift-app-${app.id}`"
              >
                <tr v-for="(item, index) in app.items" :key="`gift-${item.id}`">
                  <td
                    v-if="index === 0 && isFit(review)"
                    :rowspan="app.items.length"
                    style="width: 240px; vertical-align: middle;"
                  >
                    {{ app.user_name || '自購' }}
                  </td>
                  <td
                    v-if="index === 0 && isGroup(review)"
                    :rowspan="app.items.length"
                    style="width: 180px; vertical-align: middle;"
                  >
                    {{ app.group_code }}
                  </td>
                  <td
                    v-if="index === 0 && isGroup(review)"
                    :rowspan="app.items.length"
                    style="width: 360px; vertical-align: middle;"
                  >
                    <p v-html="app.group_name"></p>
                  </td>
                  <td
                    v-if="index === 0 && isGroup(review)"
                    :rowspan="app.items.length"
                    style="width: 120px; vertical-align: middle;"
                  >
                    {{ formatDate(app.group_departure_date) }}
                  </td>
                  <td
                    v-if="index === 0"
                    :rowspan="app.items.length"
                    style="vertical-align: middle"
                  >
                    {{ app.remark }}
                  </td>
                  <td style="width: 240px; vertical-align: middle;">
                    <p class="nowrap">
                      <span>{{ item.gift_full_name }}</span>
                      <b-tag
                        v-if="app.is_public"
                        type="is-success"
                        style="margin-right: 0.25rem"
                      >
                        {{ $t('attributes.gift_application_public') }}
                      </b-tag>
                      <b-tag
                        v-if="item.department_no === review.department_no"
                        type="is-info"
                        style="margin-left: 0.25rem"
                      >
                        {{ $t('attributes.gift_application_department') }}
                      </b-tag>
                    </p>
                  </td>
                  <td
                    style="width: 80px; text-align: right; vertical-align: middle;"
                  >
                    {{ item.quantity }}
                  </td>
                  <td
                    style="width: 80px; text-align: right; vertical-align: middle;"
                  >
                    <span
                      :class="{
                        'is-strike':
                          app.is_public ||
                          item.department_no === review.department_no
                      }"
                    >
                      {{ item.net_price }}
                    </span>
                  </td>
                  <th
                    style="width: 80px; text-align: right; vertical-align: middle;"
                  >
                    {{ formatCurrency(item.amount) }}
                  </th>
                </tr>
              </tbody>
              <tfoot>
                <tr>
                  <th
                    v-if="isFit(review)"
                    colspan="3"
                    style="text-align: center;"
                  >
                    合計
                  </th>
                  <th
                    v-if="isGroup(review)"
                    colspan="5"
                    style="text-align: center;"
                  >
                    合計
                  </th>
                  <th></th>
                  <th></th>
                  <th style="text-align: right;">
                    {{ formatCurrency(review.amount) }}
                  </th>
                </tr>
              </tfoot>
            </table>

            <div
              v-if="review !== null && review.returns.length > 0"
              style="border-top: lightgray 3px dashed; padding-top: 1rem;"
            >
              <div class="columns mb-0">
                <div class="column">
                  <p
                    class="subtitle has-text-weight-bold has-text-danger"
                    style="margin: 0.5rem;"
                  >
                    退回歷史
                  </p>
                </div>
                <div class="column is-narrow">
                  <div class="buttons">
                    <b-button
                      v-if="mode === 'review' && canReview(review.returns[0])"
                      :loading="sending"
                      type="is-success"
                      @click.prevent="onAuditReturn(review.returns[0])"
                    >
                      {{ $t('attributes.gift_application_approve') }}
                    </b-button>
                    <b-button
                      v-if="mode === 'review' && canReview(review.returns[0])"
                      :loading="sending"
                      type="is-danger"
                      @click.prevent="onRejectReturn(review.returns[0])"
                    >
                      {{ $t('attributes.gift_application_reject') }}
                    </b-button>
                  </div>
                </div>
              </div>
              <div
                v-for="(giftReturn, index) in review.returns"
                :key="`return-${index}`"
                class="box"
              >
                <table class="table is-bordered is-narrow is-fullwidth">
                  <tbody>
                    <tr>
                      <th style="width: 60px;">
                        {{ $t('attributes.gift_application_return_number') }}
                      </th>
                      <th style="width: 100px;">
                        {{ giftReturn.number }}
                      </th>
                      <th style="width: 60px;"></th>
                      <th style="width: 100px;"></th>
                      <th style="width: 60px;">
                        {{ $t('attributes.gift_review_return_total_quantity') }}
                      </th>
                      <th style="width: 100px; text-align: right;">
                        {{ giftReturn.quantity }}
                      </th>
                      <th style="width: 80px;">
                        {{ $t('attributes.gift_review_return_total_amount') }}
                      </th>
                      <th style="width: 100px; text-align: right;">
                        {{ formatCurrency(giftReturn.amount) }}
                      </th>
                    </tr>
                    <tr>
                      <th style="width: 60px;">
                        {{ $t('attributes.gift_application_state') }}
                      </th>
                      <th style="width: 100px;">
                        <P :class="stateColor(giftReturn)">
                          {{ stateName(giftReturn.state) }}
                        </P>
                      </th>
                      <th style="width: 60px;">
                        {{ $t('attributes.gift_application_submit_date') }}
                      </th>
                      <th style="width: 100px;">
                        {{ formatDateTime(giftReturn.created_at) || '-' }}
                      </th>
                      <th style="width: 60px;">
                        {{ $t('attributes.gift_application_review_date') }}
                      </th>
                      <th style="width: 100px;">
                        {{ formatDateTime(giftReturn.review_date) || '-' }}
                      </th>
                      <th style="width: 80px;">
                        {{ $t('attributes.gift_review_reviewer') }}
                      </th>
                      <th style="width: 100px;">
                        {{ reviewerName(giftReturn) }}
                      </th>
                    </tr>
                  </tbody>
                </table>

                <b-field
                  v-if="isRejected"
                  :label="$t('attributes.gift_review_reject_reason')"
                  label-position="on-border"
                >
                  <b-input
                    v-model="giftReturn.reason"
                    readonly
                    type="textarea"
                    rows="2"
                  />
                </b-field>

                <table class="table is-bordered is-narrow is-fullwidth">
                  <thead>
                    <tr>
                      <th v-if="isFit(review)" class="nowrap">
                        {{ $t('attributes.user') }}
                      </th>
                      <th v-if="isGroup(review)" class="nowrap">
                        {{ $t('attributes.travel_group') }}
                      </th>
                      <th v-if="isGroup(review)">
                        {{ $t('attributes.group_name') }}
                      </th>
                      <th v-if="isGroup(review)" class="nowrap">
                        {{ $t('attributes.departure_date') }}
                      </th>
                      <th class="nowrap">
                        {{ $t('attributes.gift_review_return_reason') }}
                      </th>
                      <th class="nowrap">{{ $t('attributes.gift') }}</th>
                      <th class="nowrap" style="text-align: right;">
                        {{ $t('attributes.gift_application_request_quantity') }}
                      </th>
                      <th class="nowrap" style="text-align: right;">
                        {{ $t('attributes.gift_application_return_quantity') }}
                      </th>
                      <th class="nowrap" style="text-align: right;">
                        {{ $t('attributes.gift_application_final_quantity') }}
                      </th>
                      <th class="nowrap" style="text-align: right;">
                        {{ $t('attributes.gift_net_price') }}
                      </th>
                      <th class="nowrap" style="text-align: right;">
                        {{ $t('attributes.gift_amount') }}
                      </th>
                    </tr>
                  </thead>
                  <tbody
                    v-for="app in giftReturn.return_applications"
                    :key="`return-app-${app.id}`"
                  >
                    <tr
                      v-for="(item, index) in app.items"
                      :key="`return-app-${app.id}-${item.id}`"
                    >
                      <td
                        v-if="index === 0 && isFit(review)"
                        :rowspan="app.items.length"
                        style="width: 240px; vertical-align: middle;"
                      >
                        {{ app.application.user_name || '自購' }}
                      </td>
                      <td
                        v-if="index === 0 && isGroup(review)"
                        :rowspan="app.items.length"
                        style="width: 180px; vertical-align: middle;"
                      >
                        {{ app.application.group_code }}
                      </td>
                      <td
                        v-if="index === 0 && isGroup(review)"
                        :rowspan="app.items.length"
                        style="width: 360px; vertical-align: middle;"
                      >
                        <p v-html="app.application.group_name"></p>
                      </td>
                      <td
                        v-if="index === 0 && isGroup(review)"
                        :rowspan="app.items.length"
                        class="nowrap"
                        style="width: 120px; vertical-align: middle;"
                      >
                        {{ app.application.group_departure_date }}
                      </td>
                      <td
                        v-if="index === 0"
                        :rowspan="app.items.length"
                        style="vertical-align: middle"
                      >
                        {{ app.remark }}
                      </td>
                      <td style="width: 240px; vertical-align: middle;">
                        <p class="nowrap">
                          <span>{{ item.item.gift_full_name }}</span>
                          <b-tag
                            v-if="app.application.is_public"
                            type="is-success"
                            style="margin-right: 0.25rem"
                          >
                            {{ $t('attributes.gift_application_public') }}
                          </b-tag>
                          <b-tag
                            v-if="
                              item.item.department_no === review.department_no
                            "
                            type="is-info"
                            style="margin-left: 0.25rem"
                          >
                            {{ $t('attributes.gift_application_department') }}
                          </b-tag>
                        </p>
                      </td>
                      <td
                        style="width: 80px; text-align: right;  vertical-align: middle;"
                      >
                        {{ item.origin_quantity }}
                      </td>
                      <td
                        style="width: 80px; text-align: right;  vertical-align: middle;"
                      >
                        {{ item.quantity }}
                      </td>
                      <td
                        style="width: 80px; text-align: right;  vertical-align: middle;"
                      >
                        {{ item.final_quantity }}
                      </td>
                      <td
                        style="width: 80px; text-align: right;  vertical-align: middle;"
                      >
                        <span
                          :class="{
                            'is-strike':
                              app.is_public ||
                              item.item.department_no === review.department_no
                          }"
                        >
                          {{ item.item.net_price }}
                        </span>
                      </td>
                      <th
                        style="width: 80px; text-align: right; vertical-align: middle;"
                      >
                        {{ formatCurrency(item.amount) }}
                      </th>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </section>

          <b-loading
            v-model="loading"
            :is-full-page="true"
            :can-cancel="false"
          />
        </div>
      </section>
      <footer class="modal-card-foot">
        <b-button
          type="is-danger"
          class="is-fullwidth"
          @click="$parent.close()"
        >
          {{ $t('attributes.close') }}
        </b-button>
      </footer>
    </div>
  </section>
</template>

<script>
import { GIFT_RETURNS_API, GIFT_REVIEWS_API } from '@/utils/apis'
import notifyService from '@/services/notifyService'
import GiftReviewMixin from '@/mixins/GiftReviewMixin'
import { GIFT_REVIEW_STATE_TYPES } from '@/utils/constants'

export default {
  name: 'Review',
  mixins: [GiftReviewMixin],

  props: {
    type: {
      type: String,
      default: 'review'
    },
    mode: {
      type: String,
      required: true,
      validator(value) {
        return ['review', 'apply'].includes(value)
      }
    },
    number: {
      required: true,
      type: String
    },
    reload_key: {
      required: true,
      type: null
    },
    loading: {
      type: Boolean,
      default: false
    },
    sending: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      review: null,

      isCancelFormModalActive: false,
      apply_type: ''
    }
  },
  watch: {
    number(newNumber) {
      this.loadReviewAsync(newNumber)
    },
    reload_key() {
      this.loadReviewAsync(this.number)
    }
  },
  mounted() {
    this.loadReviewAsync(this.number)
  },
  methods: {
    async loadReviewAsync(number) {
      try {
        let api = `${GIFT_REVIEWS_API}/${number}`
        if (this.type === 'cancel') {
          api = `${GIFT_REVIEWS_API}/cancel/${number}`
        }

        this.$emit('update:loading', true)

        const res = await this.axios.get(api)
        const review = res.data.data
        review.returns = review.returns.sort(
          (t1, t2) => new Date(t2.created_at) - new Date(t1.created_at)
        )

        this.review = review
        this.apply_type = review.apply_type
      } catch (e) {
        notifyService.fetch_error('gift_review', e)
      } finally {
        this.$emit('update:loading', false)
      }
    },
    onAudit() {
      this.$buefy.dialog.confirm({
        type: 'is-success',
        message: this.$t('message.confirm_approve_gift_review', [
          this.review.number
        ]),
        confirmText: this.$t('attributes.gift_application_approve'),
        cancelText: this.$t('attributes.cancel'),
        trapFocus: true,
        onConfirm: async () => {
          await this.audit(this.review)
        }
      })
    },
    onReject() {
      this.$buefy.dialog.prompt({
        type: 'is-danger',
        message: this.$t('message.confirm_reject_gift_review', [
          this.review.number
        ]),
        inputAttrs: {
          type: 'textarea',
          placeholder: this.$t(
            'message.please_input_gift_review_reject_reason'
          ),
          value: '',
          maxlength: 500,
          required: true
        },
        confirmText: this.$t('attributes.gift_application_reject'),
        cancelText: this.$t('attributes.cancel'),
        trapFocus: true,
        onConfirm: async reason => {
          await this.reject(this.review, reason)
        }
      })
    },
    onVoid() {
      this.$buefy.dialog.prompt({
        type: 'is-danger',
        message: this.$t('message.confirm_void_gift_review', [
          this.review.number
        ]),
        inputAttrs: {
          type: 'textarea',
          placeholder: this.$t('message.please_input_gift_review_void_reason'),
          value: '',
          maxlength: 500,
          required: true
        },
        confirmText: this.$t('attributes.gift_review_void'),
        cancelText: this.$t('attributes.cancel'),
        trapFocus: true,
        onConfirm: async number => {
          await this.void(this.review, number)
        }
      })
    },
    onClone() {
      this.$emit('clone', this.review)
    },
    onReturn() {
      this.$emit('return', this.review)
    },

    onAuditReturn(giftReturn) {
      this.$buefy.dialog.confirm({
        type: 'is-success',
        message: this.$t('message.confirm_approve_gift_review', [
          this.review.number
        ]),
        confirmText: this.$t('attributes.gift_application_approve'),
        cancelText: this.$t('attributes.cancel'),
        trapFocus: true,
        onConfirm: async () => {
          await this.auditReturn(giftReturn)
        }
      })
    },
    onRejectReturn(giftReturn) {
      this.$buefy.dialog.prompt({
        type: 'is-danger',
        message: this.$t('message.confirm_reject_gift_review', [
          this.review.number
        ]),
        inputAttrs: {
          type: 'textarea',
          placeholder: this.$t(
            'message.please_input_gift_review_reject_reason'
          ),
          value: '',
          maxlength: 500,
          required: true
        },
        confirmText: this.$t('attributes.gift_application_reject'),
        cancelText: this.$t('attributes.cancel'),
        trapFocus: true,
        onConfirm: async reason => {
          await this.rejectReturn(giftReturn, reason)
        }
      })
    },

    onPrint() {
      this.print(this.review)
    },
    onPrintReturn(item) {
      this.printReturn(item)
    },

    async print(review) {
      const api = `${GIFT_REVIEWS_API}/${review.number}/print`

      const config = {
        headers: { Accept: 'application/pdf' },
        responseType: 'blob',
        errorHandle: {
          customMessage: `${this.$t('attributes.fetch_failed', [
            this.$t('attributes.order')
          ])}: `
        }
      }

      try {
        this.$emit('update:loading', true)

        const response = await this.axios.get(api, config)
        const fileName = `申請表-${review.number}.pdf`

        const blob = new Blob([response.data], { type: response.data.type })
        const url = window.URL.createObjectURL(blob)
        const link = document.createElement('a')
        link.href = url
        link.setAttribute('download', fileName)
        document.body.appendChild(link)
        link.click()
        link.remove()
        window.URL.revokeObjectURL(url)
      } catch (e) {
        notifyService.error('下載申請表失敗', e)
      } finally {
        this.$emit('update:loading', false)
      }
    },

    async printReturn(item) {
      const api = `${GIFT_RETURNS_API}/${item.number}/print`

      const config = {
        headers: { Accept: 'application/pdf' },
        responseType: 'blob',
        errorHandle: {
          customMessage: `${this.$t('attributes.fetch_failed', [
            this.$t('attributes.order')
          ])}: `
        }
      }

      try {
        this.$emit('update:loading', true)

        const response = await this.axios.get(api, config)
        const fileName = `贈品退回申請單-${item.number}.pdf`

        const blob = new Blob([response.data], { type: response.data.type })
        const url = window.URL.createObjectURL(blob)
        const link = document.createElement('a')
        link.href = url
        link.setAttribute('download', fileName)
        document.body.appendChild(link)
        link.click()
        link.remove()
        window.URL.revokeObjectURL(url)
      } catch (e) {
        notifyService.error('下載申請表失敗', e)
      } finally {
        this.$emit('update:loading', false)
      }
    },
    onCancelApply(item) {
      this.$buefy.dialog.confirm({
        message: '確定要取消此筆申請?',
        confirmText: '確定',
        onConfirm: () => {
          this.cancelApply(item)
        }
      })
    },
    async cancelApply(item) {
      try {
        this.$emit('update:sending', true)

        const api = `${GIFT_REVIEWS_API}/${item.number}/delete`
        const res = await this.axios.put(api, {})
        this.review = res.data.data

        notifyService.success(this.$t('attributes.cancel_apply_succeed'))

        this.$emit('deleted')
      } catch (e) {
        notifyService.update_error(e)
      } finally {
        this.$emit('update:sending', false)
      }
    },
    async audit(item) {
      try {
        this.$emit('update:sending', true)

        const api = `${GIFT_REVIEWS_API}/${item.number}/audit`
        const res = await this.axios.put(api, {})
        this.review = res.data.data

        notifyService.success(this.$t('attributes.approve_succeed'))

        this.$emit('audit')
      } catch (e) {
        notifyService.update_error(e)
      } finally {
        this.$emit('update:sending', false)
      }
    },
    async reject(item, reason) {
      try {
        this.$emit('update:sending', true)

        const api = `${GIFT_REVIEWS_API}/${item.number}/reject`
        const res = await this.axios.put(api, { reason })
        this.review = res.data.data

        notifyService.success(this.$t('attributes.reject_succeed'))

        this.$emit('rejected')
      } catch (e) {
        notifyService.update_error(e)
      } finally {
        this.$emit('update:sending', false)
      }
    },
    async void(item, reason) {
      try {
        this.$emit('update:sending', true)

        const api = `${GIFT_REVIEWS_API}/${item.number}/void`
        const res = await this.axios.put(api, { reason })
        this.review = res.data.data

        notifyService.success(this.$t('attributes.void_succeed'))

        this.$emit('void')
      } catch (e) {
        notifyService.update_error(e)
      } finally {
        this.$emit('update:sending', false)
      }
    },

    async auditReturn(item) {
      try {
        this.$emit('update:sending', true)

        const api = `${GIFT_RETURNS_API}/${item.number}/audit`
        await this.axios.put(api, {})

        notifyService.success(this.$t('attributes.approve_succeed'))

        this.$emit('audited')
      } catch (e) {
        notifyService.update_error(e)
      } finally {
        this.$emit('update:sending', false)
      }
    },
    async rejectReturn(item, reason) {
      try {
        this.$emit('update:sending', true)

        const api = `${GIFT_RETURNS_API}/${item.number}/reject`
        await this.axios.put(api, { reason })

        notifyService.success(this.$t('attributes.reject_succeed'))

        this.$emit('rejected')
      } catch (e) {
        notifyService.update_error(e)
      } finally {
        this.$emit('update:sending', false)
      }
    },

    stateColor(item) {
      switch (item.state) {
        case GIFT_REVIEW_STATE_TYPES.PENDING:
          return 'has-text-weight-bold has-text-danger'
        case GIFT_REVIEW_STATE_TYPES.AUDIT:
          return 'has-text-weight-bold has-text-success'
        case GIFT_REVIEW_STATE_TYPES.REJECT:
          return 'has-text-weight-bold has-text-warning-dark'
        case GIFT_REVIEW_STATE_TYPES.CANCEL:
          return 'has-text-weight-bold has-text-success'
        case GIFT_REVIEW_STATE_TYPES.VOID:
          return 'has-text-weight-bold has-text-grey'
      }
    },

    async setReviewLock(review) {
      try {
        const data = {
          number: review.number,
          lock: review.lock ? 0 : 1
        }
        this.$emit('update:sending', true)

        const api = `${GIFT_REVIEWS_API}/setLock`
        await this.axios.put(api, data)

        notifyService.success(this.$t('attributes.reject_succeed'))

        this.$emit('rejected')
      } catch (e) {
        notifyService.update_error(e)
      } finally {
        this.$emit('update:sending', false)
      }
    }
  }
}
</script>
